export default "/images/vendor/@coreui/icons/svg/flag/cif-cz.svg?8657ca0338c81fb9471295275cb1ebc6";